import React, { FC } from 'react';
import cn from 'classnames/bind';
import { FormattedMessage } from 'react-intl';

import { Button } from '@/shared/components/Button/Button';

import { SessionStopImage } from './SessionStopImage';
import styles from './SessionStop.module.css';

interface Props {
    channelLogoUrl: string | undefined;
    channelTitle: string | undefined;
    message: React.ReactNode;
    backToLiveButton?: (button: React.ReactNode) => React.ReactNode;
    onClick?: () => void;
}

const cx = cn.bind(styles);

export const SessionStopScreen: FC<Props> = ({
    channelTitle,
    channelLogoUrl,
    message,
    backToLiveButton = (button) => button,
    onClick,
}) => (
    <div className={cx('container')}>
        {channelLogoUrl && <SessionStopImage title={channelTitle} posterUrl={channelLogoUrl} />}
        <div className={cx('title')}>{message}</div>
        {backToLiveButton(
            <Button size={44} variant="accent" onClick={onClick}>
                <FormattedMessage
                    id="components.SessionStop.eae32f89c997222c9859e0e8cd80379c"
                    defaultMessage="Back to the stream"
                    description="Текст кнопки возврата в эфир"
                />
            </Button>
        )}
    </div>
);
